import { render, staticRenderFns } from "./shifu_bidding.vue?vue&type=template&id=4b861cd8&scoped=true&"
import script from "./shifu_bidding.vue?vue&type=script&lang=js&"
export * from "./shifu_bidding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b861cd8",
  null
  
)

export default component.exports